import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { auth } from "../../firebase";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");

  const handleReset = async () => {
    const trimmedEmail = email.trim();

    if (!trimmedEmail) {
      setErr("Please enter your email.");
      setMsg("");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, trimmedEmail, {
        url: "http://localhost:3000/reset-password", // 🔁 Change to your actual URL
        handleCodeInApp: true,
      });
      setMsg("Reset link sent! Check your inbox.");
      setErr("");
    } catch (error) {
      console.error(error);
      setErr("Failed to send reset email. Please check the email address.");
      setMsg("");
    }
  };

  return (
    <div className="container py-5 text-center" style={{ maxWidth: 400 }}>
      <h2 className="mb-4">Reset Your Password</h2>

      <input
        type="email"
        placeholder="Enter your email"
        className="form-control mb-3"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />

      <button className="btn btn-dark w-100 mb-3" onClick={handleReset}>
        Send Reset Email
      </button>

      {msg && <p className="text-success mt-2">{msg}</p>}
      {err && <p className="text-danger mt-2">{err}</p>}
    </div>
  );
}
